// GTM Hub constants
export const GTM_USE_CASES = [
  "AML / Transaction Monitoring",
  "KYC / Customer Due Diligence",
  "Fraud Detection",
  "Sanctions Screening",
  "Trade-Based Money Laundering",
  "Beneficial Ownership Transparency",
  "Supply Chain Risk Management",
  "ESG / Greenwashing Detection",
  "Vendor / Third-Party Risk",
  "Regulatory Reporting",
  "Customer Risk Scoring",
  "Network / Relationship Analytics",
  "Entity Resolution",
  "Adverse Media Screening",
  "PEP Screening",
  "Insider Threat Detection",
  "Cyber Fraud Detection",
  "Payment Fraud",
  "Insurance Fraud",
  "Procurement Fraud",
  "Tax Fraud",
  "Invoice Fraud",
  "Anti-Bribery & Corruption",
  "Counterparty Due Diligence",
  "Credit Risk Analytics",
  "Market Surveillance",
  "Disinformation Detection",
  "Supply Chain Traceability",
  "Carbon Footprint Tracking",
  "Forced Labor Detection",
  "Conflict Minerals Screening",
  "Data Quality / Deduplication"
];

export const GTM_SECTOR_UC = {
  "Banking": [
    "AML / Transaction Monitoring",
    "KYC / Customer Due Diligence",
    "Fraud Detection",
    "Sanctions Screening",
    "Trade-Based Money Laundering",
    "Beneficial Ownership Transparency",
    "Customer Risk Scoring",
    "PEP Screening",
    "Adverse Media Screening",
    "Network / Relationship Analytics"
  ],
  "Telecom": [
    "Fraud Detection",
    "Supply Chain Risk Management",
    "Vendor / Third-Party Risk",
    "Entity Resolution",
    "Customer Risk Scoring",
    "Cyber Fraud Detection",
    "Payment Fraud",
    "Network / Relationship Analytics"
  ],
  "Manufacturing": [
    "Supply Chain Risk Management",
    "ESG / Greenwashing Detection",
    "Vendor / Third-Party Risk",
    "Supply Chain Traceability",
    "Forced Labor Detection",
    "Conflict Minerals Screening",
    "Carbon Footprint Tracking",
    "Procurement Fraud",
    "Anti-Bribery & Corruption"
  ],
  "Government": [
    "AML / Transaction Monitoring",
    "Fraud Detection",
    "Beneficial Ownership Transparency",
    "Sanctions Screening",
    "Tax Fraud",
    "Regulatory Reporting",
    "Entity Resolution",
    "Network / Relationship Analytics",
    "Anti-Bribery & Corruption",
    "Disinformation Detection"
  ],
  "Conglomerate": [
    "Supply Chain Risk Management",
    "ESG / Greenwashing Detection",
    "Vendor / Third-Party Risk",
    "Beneficial Ownership Transparency",
    "Anti-Bribery & Corruption",
    "Counterparty Due Diligence",
    "Entity Resolution",
    "Network / Relationship Analytics"
  ],
  "Regulator": [
    "AML / Transaction Monitoring",
    "Beneficial Ownership Transparency",
    "Regulatory Reporting",
    "Sanctions Screening",
    "Network / Relationship Analytics",
    "Entity Resolution",
    "Market Surveillance",
    "Tax Fraud"
  ]
};

export const GTM_COMPETITORS = [
  "Quantexa",
  "Palantir",
  "Neo4j",
  "TigerGraph",
  "NICE Actimize",
  "SAS",
  "Featurespace",
  "Exiger",
  "ComplyAdvantage",
  "Refinitiv (LSEG)",
  "LexisNexis Risk",
  "Dow Jones Risk",
  "Bureau van Dijk",
  "Sayari",
  "Altana AI",
  "Interos",
  "Chainalysis",
  "Elliptic",
  "TRM Labs",
  "DataVisor",
  "Hawk AI",
  "Lucinity",
  "Verafin",
  "WorkFusion",
  "Napier AI",
  "Unit21",
  "Flagright",
  "BioCatch",
  "Shift Technology",
  "Oracle Financial Services",
  "FIS",
  "Actimize",
  "Clari5",
  "Zigram",
  "Trackwizz",
  "Handshakes",
  "Crystal Intelligence",
  "Hummingbird",
  "Informatica",
  "Tamr",
  "DataRobot",
  "Databricks",
  "Snowflake",
  "Dataiku",
  "Alteryx",
  "C3.ai",
  "Accenture",
  "McKinsey",
  "Deloitte",
  "EY",
  "PwC",
  "KPMG"
];

export const GTM_FLAGS = {Singapore:'🇸🇬',Malaysia:'🇲🇾',Indonesia:'🇮🇩',India:'🇮🇳',Thailand:'🇹🇭',Vietnam:'🇻🇳',Philippines:'🇵🇭','Saudi Arabia':'🇸🇦',UAE:'🇦🇪',France:'🇫🇷',Germany:'🇩🇪',Italy:'🇮🇹',Denmark:'🇩🇰'};

export const GTM_OWNERS = ['Ajay','Gilbert','Nick','Partha','Attif'];

export const GTM_OWNER_ROLES = {Ajay:'CEO — Central Banks & Regulators',Gilbert:'CRO — Banking',Nick:'BD — Telecom, Mfg, Govt, Conglomerates',Partha:'India Lead — All Sectors',Attif:'ME & EU Lead — All Sectors'};

export const GTM_COUNTRIES = ['Singapore','Malaysia','Indonesia','India','Thailand','Vietnam','Philippines','Saudi Arabia','UAE','France','Germany','Italy','Denmark'];

export const GTM_REGIONS = ['APAC','Middle East','EU'];

export const GTM_SECTORS = ['Banking','Telecom','Manufacturing','Government','Conglomerate','Regulator'];

export const GTM_STATUSES = ['prospect','contacted','meeting','proposal','poc','closed','lost'];
